/* SHOP-008 - Ofertas por kilos - Aceitunas Lopez - v1.6.0
   Solo calcula y pinta. El precio real lo aplican los descuentos automaticos
   de Shopify. Los textos salen de las casillas del bloque.

   REGLA DEL ATAJO
     Pulsar una tarjeta significa "quiero este total".
       · Si el cliente NO ha tocado las cantidades a mano, todos los kilos van
         a una sola variedad: la que ya tenia kilos, o la primera.
       · Si SI las ha tocado, se respeta lo escrito: al subir, los kilos que
         faltan van a la variedad que este a cero; al bajar, se reparte el
         nuevo total entre las que ya tenian kilos, en la misma proporcion.
     Nunca deja de responder y nunca borra una variedad entera sin motivo.

   QUE CAMBIA EN 1.6.0 - avisa del precio del tramo, pero no pinta el precio
     Este bloque NO toca el bloque del precio. Se probo una vez a que lo
     reescribiera desde aqui y salio mal: tapaba el (€/kg) de SHOP-002, que es
     una constante de la tienda y tiene que estar siempre.
     Ahora solo ANUNCIA. Cada vez que cambia la seleccion emite:

       aceitunas:preciotramo  { kg, precio, total }

     donde precio es el precio efectivo del kilo con el tramo aplicado (en
     euros). Quien decide como se muestra eso es SHOP-002
     (blocks/_product-price.liquid), que es el dueno de esa zona y el que sabe
     dividir por el peso escurrido. Si ese bloque no esta en la plantilla, el
     aviso se emite y no lo escucha nadie: aqui no se rompe nada. */
(function () {
  'use strict';

  function eur(n) {
    return n.toFixed(2).replace('.', ',') + '€';
  }

  function linea(html) {
    var d = document.createElement('div');
    d.innerHTML = html;
    return d;
  }

  function init(root) {
    if (!root || root.dataset.listo === '1') return;
    root.dataset.listo = '1';

    var datos = {};
    try {
      datos = JSON.parse(root.querySelector('script[data-altr-json]').textContent);
    } catch (e) {
      return;
    }

    var campos = Array.prototype.slice.call(root.querySelectorAll('[data-altr-qty]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-altr-card]'));
    var elKg = root.querySelector('[data-altr-total-kg]');
    var elEur = root.querySelector('[data-altr-total-eur]');
    var elNext = root.querySelector('[data-altr-next]');
    var btn = root.querySelector('[data-altr-add]');
    var activo = campos[0] || null;
    var manual = false;

    function val(campo) {
      var n = parseInt(campo.value, 10);
      if (isNaN(n) || n < 0) n = 0;
      return n;
    }

    function totalKg() {
      var t = 0;
      campos.forEach(function (c) { t += val(c); });
      return t;
    }

    function precioDe(kg) {
      var p = datos.base;
      datos.tramos.forEach(function (t) { if (kg >= t.min) p = t.precio; });
      return p;
    }

    function conKilos() {
      return campos.filter(function (c) { return val(c) > 0; });
    }

    /* Reparte un total mas pequeno entre las variedades que ya tienen kilos,
       guardando la proporcion y sin perder ni sumar kilos por redondeo. */
    function repartir(objetivo) {
      var actual = totalKg();
      var lista = conKilos();
      if (!lista.length) return;

      var repartido = 0;
      lista.forEach(function (c, i) {
        var n;
        if (i === lista.length - 1) {
          n = objetivo - repartido;
        } else {
          n = Math.round((val(c) * objetivo) / actual);
          var tope = objetivo - repartido - (lista.length - 1 - i);
          if (n < 1) n = 1;
          if (n > tope) n = tope;
        }
        if (n < 0) n = 0;
        c.value = n;
        repartido += n;
      });
    }

    function avisarPrecio(kg, p, total) {
      if (typeof CustomEvent !== 'function') return;
      document.dispatchEvent(new CustomEvent('aceitunas:preciotramo', {
        detail: { kg: kg, precio: p, total: total }
      }));
    }

    function pintar() {
      var kg = totalKg();
      var p = precioDe(kg);
      var total = kg * p;

      elKg.textContent = kg ? kg + ' kg → ' + eur(p) + '/kg' : datos.txt_vacio;
      elEur.textContent = kg ? eur(total) : '';

      elNext.innerHTML = '';

      var gana = [];
      if (datos.envio_desde > 0 && total >= datos.envio_desde) gana.push(datos.txt_envio);
      if (datos.regalo && kg >= datos.regalo_desde) gana.push(datos.regalo);
      if (gana.length && datos.txt_incluye) {
        elNext.appendChild(linea(datos.txt_incluye + ' ' + gana.join(' y ')));
      }

      var sig = null;
      datos.tramos.forEach(function (t) { if (!sig && kg < t.min) sig = t; });
      if (kg > 0 && sig && datos.txt_falta) {
        var faltan = sig.min - kg;
        var txt = datos.txt_falta
          .replace('{kg}', '<strong>' + faltan + ' kg</strong>')
          .replace('{precio}', eur(sig.precio));
        if (faltan === 1) {
          txt = txt.replace('faltan', 'falta').replace('añadirlos', 'añadirlo');
        }
        elNext.appendChild(linea(txt));
      }

      elNext.style.display = elNext.children.length ? '' : 'none';

      cards.forEach(function (c) {
        c.classList.toggle('is-on', parseInt(c.dataset.altrCard, 10) === kg);
      });

      if (btn) {
        btn.disabled = kg === 0;
        btn.textContent = kg === 0 ? datos.txt_boton_vacio : datos.txt_boton;
      }

      avisarPrecio(kg, p, total);
    }

    campos.forEach(function (campo) {
      campo.addEventListener('input', function () { activo = campo; manual = true; pintar(); });
      campo.addEventListener('focus', function () { activo = campo; });
    });

    root.addEventListener('click', function (e) {
      var mas = e.target.closest('[data-altr-step]');
      if (mas) {
        var campo = root.querySelector('[data-altr-qty="' + mas.dataset.altrFor + '"]');
        if (!campo) return;
        activo = campo;
        manual = true;
        campo.value = Math.max(0, val(campo) + parseInt(mas.dataset.altrStep, 10));
        pintar();
        return;
      }

      var card = e.target.closest('[data-altr-card]');
      if (!card) return;

      var objetivo = parseInt(card.dataset.altrCard, 10);
      var actual = totalKg();
      if (actual === objetivo) { pintar(); return; }

      if (!manual) {
        var lista = conKilos();
        var uno = lista.length ? lista[0] : (campos[0] || null);
        if (!uno) return;
        campos.forEach(function (c) { if (c !== uno) c.value = 0; });
        uno.value = objetivo;
        pintar();
        return;
      }

      if (actual > objetivo) {
        repartir(objetivo);
        pintar();
        return;
      }

      var libres = campos.filter(function (c) { return !c.disabled && val(c) === 0; });
      var destino = libres.length ? libres[0] : (activo && !activo.disabled ? activo : campos[0]);
      if (!destino) return;
      var otros = 0;
      campos.forEach(function (c) { if (c !== destino) otros += val(c); });
      destino.value = objetivo - otros;
      pintar();
    });

    if (btn) {
      btn.addEventListener('click', function () {
        var items = [];
        campos.forEach(function (c) {
          var q = val(c);
          if (q > 0) items.push({ id: parseInt(c.dataset.altrQty, 10), quantity: q });
        });
        if (!items.length) return;
        btn.disabled = true;
        btn.textContent = datos.txt_boton_espera;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j && res.j.description ? res.j.description : 'error');
            window.location.href = '/cart';
          })
          .catch(function (err) {
            btn.disabled = false;
            btn.textContent = datos.txt_boton;
            elNext.style.display = '';
            elNext.textContent = String(err.message || err);
          });
      });
    }

    pintar();
  }

  function arranque(scope) {
    (scope || document).querySelectorAll('[data-altr]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arranque(document); });
  } else {
    arranque(document);
  }

  document.addEventListener('shopify:section:load', function (e) { arranque(e.target); });
  document.addEventListener('shopify:block:select', function (e) { arranque(e.target); });
})();
